"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useInputPadding", {
    enumerable: true,
    get: function() {
        return useInputPadding;
    }
});
const _react = require("react");
const _FormInputGroupContext = require("./FormInputGroup/FormInputGroupContext");
const useInputPadding = function() {
    let { top = "8px", right = "16px", left = "16px", bottom = "8px" } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { hasSuffix, hasPrefix, direction } = (0, _react.useContext)(_FormInputGroupContext.FormInputGroupContext);
    const shorthand = (0, _react.useMemo)(()=>{
        if (direction === "row") {
            return "".concat(top, " ").concat(hasSuffix ? "0" : right, " ").concat(bottom, " ").concat(hasPrefix ? "0" : left);
        } else {
            return "0 ".concat(right, " 0 ").concat(left);
        }
    }, [
        hasSuffix,
        hasPrefix,
        direction,
        top,
        right,
        bottom,
        left
    ]);
    return {
        shorthand,
        top,
        right,
        bottom,
        left
    };
};

//# sourceMappingURL=useInputPadding.js.map